<div class="add-relationship-to-obj">
  <div class="add-relationship-to-obj__header">
    <div class="add-relationship-to-obj__header__title">Add New Relationship</div>
    <button class="add-relationship-to-obj__header__close" mat-icon-button (click)="close()" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  </div>

  <div class="add-relationship-to-obj__content">
    <form [formGroup]="addRelationshipToObjectForm">
      <div class="add-relationship-to-obj__content__fields">
        <mat-form-field>
          <mat-label>Object</mat-label>
          <mat-select formControlName="linked_type">
            <mat-option
              *ngFor="
                let option of customObjectOptions | tsFilterBy: [] : (isInverseRelationshipOn$ | async) : filterObjects
              "
              [value]="option.name"
              >{{ option.label }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Relationship Type</mat-label>
          <mat-select formControlName="relationship_type">
            <mat-option value="one_to_many">One to many</mat-option>
            @if (isInverseRelationshipOn$ | async) {
              <mat-option value="many_to_many">Many to many</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="add-relationship-to-obj__content__actions">
        <div>
          @if (!isSaveBtnDisabled) {
            @if (addRelationshipToObjectForm.get('relationship_type').value === 'one_to_many') {
              <p class="text-secondary mb-6">One {{ linkedObject.label }} has many {{ customObject.label_plural }}.</p>
            } @else {
              <p class="text-secondary mb-6">
                Many {{ linkedObject.label_plural }} have many {{ customObject.label_plural }}.
              </p>
            }
          }
        </div>
        <div>
          <button mat-button type="button" (click)="close()">
            <span>Cancel</span>
          </button>

          <button
            class="ml-2"
            mat-flat-button
            [color]="'primary'"
            type="submit"
            [disabled]="isSaveBtnDisabled"
            DebounceClick
            (debounceLoading)="isDebounceLoading($event)"
            (debounceClick)="saveAndClose()"
          >
            <span *ngIf="!isLoading">Save</span>
            <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
